import Swiper, {Navigation} from "swiper";
Swiper.use([Navigation]);

class Timeline {

    constructor() {

        /* timeline pagination */
        this.setButtonProperty();
        $(document).on('click', '.show-more-timeline', this.hasMore.bind(this));

        /* timeline slider */
        const swiper = new Swiper('.timeline-slider-wrapper', {
            slidesPerView: 'auto',
            spaceBetween: 35,
            freeMode: true,
            navigation: {
                nextEl: ($('.timeline-slider-controls .btn-next') as any).get(0),
                prevEl: ($('.timeline-slider-controls .btn-prev') as any).get(0),
                hiddenClass: 'd-none',
                disabledClass: 'd-none',
            }
        });

        console.log('asf')
        const slideId = $('.timeline-slider-current-item').data('slickId');
        if (slideId) {
            swiper.slideTo(slideId);
        }
        /*($('.timeline-slider-controls .btn-next') as any).on('click', () => {
            swiper.slideNext();
        });
        ($('.timeline-slider-controls .btn-prev') as any).on('click', () => {
            swiper.slidePrev();
        });*/
    }

    getNextDayLink() {
        let result = 0;
        let btns = $('.b-mobile-timeline .btn.btn-timeline-day');
        btns.each((i, e) => {
            if ($(e).hasClass('active')) {
                result = i + 1;
                return;
            }
        });

        return btns.length === result
            ? false
            : $($('.btn.btn-timeline-day')[result]).attr('href');
    }

    setButtonProperty() {
        if ($('.timeline-item.d-none').length === 0) {
            setTimeout(() => {
                let nextDayLink = this.getNextDayLink();
                if (nextDayLink)
                    $('.show-more-timeline').attr('href', nextDayLink);
                else
                    $('.show-more-timeline').prop('disabled', true).css('opacity', .4);
            }, 1000);
        }
    }

    hasMore() {
        $(`.timeline-item.d-none:lt(4)`).removeClass('d-none');
        this.setButtonProperty();
    }
}

export default Timeline;
